// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".view[data-v-2abafee5]{position:absolute;width:100%;top:0;bottom:0;background-color:#90ee90}.vertical-center[data-v-2abafee5]{min-height:85%;min-height:85vh;display:flex;align-items:center}.ratio[data-v-2abafee5]{width:100%;height:0;padding-bottom:56.25%}#viewport[data-v-2abafee5]{display:block;height:auto;width:100%;font-size:80%}.border[data-v-2abafee5]{border:1px solid #ddd}h1[data-v-2abafee5]{font-weight:700!important}", ""]);
// Exports
module.exports = exports;
